import { Catalog } from '@df/catalog/catalog.interfaces';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
export namespace NBasketTotalModal {
    /**
     * Component id and block url
     */
    export const BLOCK_ID = 'basket-total';
    /**
     * Multiste modal bLock
     */
    export type IBlock = ICmsBlock<IBlockData>;
    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;
    export interface IBlockDataContent {
        image: string;
        title: string;
        subtitle1?: string;
        subtitle2?: string;
        goals: IBasketTotalModalGoal[];
    }
    export interface IBasketTotalModalGoal {
        currency: string;
        goal: number;
    }
}
